import styled from '@emotion/styled';

export const Header = styled.div`
    padding: 1rem ${({ theme }) => theme.card.padding.horizontal}px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.light};
    display: flex;
    justify-content: space-between;
    align-items: center;
`;
